import { SVGProps } from 'react';

export const IconCustomers = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='3 3 20 20'>
      <circle cx='9.5' cy='8.5' r='3.5' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.9119 11.9879C13.4214 11.9448 13.3841 11.3105 13.7178 10.9485C14.2996 10.3173 14.6583 9.45314 14.6583 8.5C14.6583 7.54686 14.2996 6.6827 13.7178 6.05152C13.3841 5.68947 13.4214 5.05524 13.9119 5.01208C14.0028 5.00408 14.0947 5 14.1875 5C16.0073 5 17.4825 6.567 17.4825 8.5C17.4825 10.433 16.0073 12 14.1875 12C14.0947 12 14.0028 11.9959 13.9119 11.9879Z'
        fill='currentColor'
      />
      <path
        d='M4.5 16C4.5 14.3431 5.84315 13 7.5 13H12.5C14.1569 13 15.5 14.3431 15.5 16V18C15.5 18.5523 15.0523 19 14.5 19H5.5C4.94771 19 4.5 18.5523 4.5 18V16Z'
        fill='currentColor'
      />
      <path
        d='M18.5 19H17.6977C17.3124 19 17 18.6876 17 18.3023V15.6359C17 14.6888 16.5556 13.7967 15.7997 13.2262C15.7034 13.1535 15.7548 13 15.8755 13H16.5869C18.1958 13 19.5 14.3042 19.5 15.9131V18C19.5 18.5523 19.0523 19 18.5 19Z'
        fill='currentColor'
      />
    </svg>
  );
};
